import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[cf-loader-spinner-container]',
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <ng-container>
      <ng-container *ngIf="showSpinner; else tmp">
        <mat-spinner [diameter]="32" class="mx-auto my-3"></mat-spinner>
      </ng-container>

      <ng-template #tmp>
        <ng-content></ng-content>
      </ng-template>
    </ng-container>
  `,
  styleUrls: ['./loader-spinner-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderSpinnerContainerComponent {
  @Input({ required: true }) showSpinner!: boolean;

  // constructor(public loadingService: LoadingService) {}
}
